import "./App.css";
import { SnackbarProvider } from 'notistack'; // or your NotificationProvider
import { NotificationProvider } from "./utils/NotificationContext.js";
import Login from "./Login/Login/Login.jsx";
import Signup from "./Login/SignUp/SignUp.jsx";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import ManningAggrement from "./Vessel_Owner/ManningAggrement/ManningAggrement.jsx";
import HomePage from "./Homepage/HomePage.jsx";
import ManningAggrementDisplay from "./Vessel_Owner/ManningAggrementDisplay/ManningAggrementDisplay.jsx";
import VesselOwnerTable from "./Vessel_Owner/VesselOwnerTable/VesselOwnerTable.jsx";
import VesselOwnerForm from "./Vessel_Owner/VesselOwnerForm/VesselOwnerForm.jsx";
import VesselForm from "./Vessel_Owner/VesselForm/VesselForm.jsx";
import VesselTable from "./Vessel_Owner/VesselTable/VesselTable.jsx";
import VesselMangerForm from "./Vessel_Manager/VesselMangerForm/VesselMangerForm.jsx";
import CrewingAgentTable from "./Crewing_Agent/Crewing_agent_table/CrewingAgentTable.jsx";
import CrewingAgentForm from "./Crewing_Agent/Crewing_agentForm/CrewingAgentForm.jsx";
import VesselManagerTable from "./Vessel_Manager/VesselMangerTable/VesselMangerTable.jsx";
import AssignedVesselTable from "./Vessel_Owner/AssignedVesselTable/AssignedVesselTable.jsx";
import CrewProfile from "./crew/CrewProfile/CrewProfile.jsx";
import CrewProfileTable from "./crew/CrewProfileTable/CrewProfileTable.jsx";
import AssignedCrew from "./crew/AssignedCrew/AssignedCrew.jsx"
import AgentDetails from "./AgentDetails.jsx";
import ContractForm from "./Contract/ContractForm/ContractForm.jsx";
import ContractTable from "./Contract/ContractTable/ContractTable.jsx";
import EditContractTable from "./Contract/EditContractTable/EditContractTable.jsx";
import CompanyVessel from "./CompanyVessel/CompanyVessel.jsx";
import ExecutiveForm from "./CompanyVessel/ExecutiveForm/ExecutiveForm.jsx";
import ExecutiveTable from "./CompanyVessel/ExecutiveTable/ExecutiveTable.jsx";
import './style/tailwind.css'
import Otp from "./Login/OTP/otp.jsx";
import ForgotPassword from "./Login/ForgotPassword/ForgotPassword.jsx";
import CrewInfo from "./crew/CrewInfo/CrewInfo.jsx";
import VesselOwnerInfo from "./Vessel_Owner/VesselOwnerInfo/VesselOwnerInfo.jsx";
import ExecutiveVesselInfo from "./CompanyVessel/ExecutiveVesselInfo/ExecutiveVesselInfo.jsx";
import VesselTableByVesselOwnerId from "./Vessel_Owner/VesselTable/VesselTableByVesselOwnerId.jsx";
import Vesselsforagent from "./Vessel_Owner/Vesselsforagent/Vesselsforagent.jsx";
import AddRank from "./crew/Rank/AddRank/AddRank.jsx";
import RankTable from "./crew/Rank/Rank/RankTable.jsx";
import { Add } from "@mui/icons-material";
import CreateRank from "./crew/Rank/CreateRank/CreateRank.jsx";
import ContractUpdate from "./Contract/UpdateContarct/ContractUpdate.jsx";
import { ThemeProvider, createTheme } from "@mui/material";
import AdminSignup from "./Login/AdminSignup/AdminSignup.jsx";
// import ContractDocument from "./Contract/ContractDocument/ContractDocument.jsx";
import CrewingAgentContractDocument from "./Contract/ContractDocument/CrewingAgentContractDocument.jsx";
import VesselOwnerContract from "./Vessel_Owner/VesselOwnerContract/VesselOwnerContract.jsx";
import SignInSignOff from "./Contract/SignInSignOff/SignInSignOff.jsx";
import ExpiringShipDetails from "./Vessel_Owner/VesselTable/getExpiryDatedvessels.jsx";
import UserList from "./adminAcess/UserList.jsx";
import AdminDashboard from "./AdminDashboard/AdminDashboard.jsx";

import AllAdminCrewing from "./AdminDashboard/AllAdminCrewing.jsx";
import AllAdminContract from "./AdminDashboard/AllAdminContract/AllAdminContract.jsx"
import AdminContractDetails from "./AdminDashboard/AllAdminContract/AdminContractDetails.jsx";
import CrewAgentDetails from "./AdminDashboard/crewingagentDetails.jsx";
import CharteredVessel from "./Vessel_Owner/CharteredVessel/CharteredVessel.jsx";
import VesselOwnerContracts from "./Vessel_Owner/VesselOwnerContracts/VesselOwnerContracts.jsx";
import VesselOwnerLayouts from "./Layouts/VesselOwnerLayouts.jsx";
import VesselOwnerProfile from "./Vessel_Owner/VesselOwner/VesselOwnerProfile.jsx";
import DashBoard from "./Vessel_Owner/VesselOwner/DashBoard.jsx";
import AddVessel from "./Vessel_Owner/VesselOwner/AddVessel.jsx";
import VesselList from "./Vessel_Owner/VesselOwner/VesselList.jsx";
import AssignedVessel from "./Vessel_Owner/VesselOwner/AssignedVessel.jsx";
import AddCrew from "./Vessel_Owner/VesselOwner/AddCrew.jsx";
import CrewList from "./Vessel_Owner/VesselOwner/CrewList.jsx";
import BsmContracts from "./Vessel_Owner/VesselOwner/BsmContracts.jsx";
import VesselContarcts from "./Vessel_Owner/VesselOwner/VesselContarcts.jsx";
import SetPermissionPage from "./permissionPage/permission.jsx"
import SignInSignOffCrewing from "./Crewing_Agent/SignInSignOffCrewing/SignInSignOffCrewing.jsx";
import AddExecutive from "./Vessel_Owner/VesselOwner/AddExecutive.jsx";
import ExecutiveList from "./Vessel_Owner/VesselOwner/ExecutiveList.jsx";
import ContractForVesselOwner from "./Contract/ContractTable/VesselOwnersContract.jsx";
import CrewingAgentFormIList from "./Crewing_Agent/CrewingAgentFormI/CrewingAgentFormIList.jsx";
import PendingFormI from "./Contract/PendingFormI/PendingFormI.jsx";
import CrewAssigned from "./Crewing_Agent/CrewAssignedtoCrewingAgent/CrewAssigned.jsx";
import SeaServiceProfileWrapper from "./Crewing_Agent/SeaServiceProfile/SeaServiceProfileWrapper.jsx"
import AssignedCrewList from "./Crewing_Agent/ListOfAssignedCrew/AssignedCrewList.jsx";
import AccountsLogin from "./Accounts/AccountsLogin.jsx";
import AccountDetails from "./Accounts/AccountDetails.jsx";
import AccountsLayout from "./Accounts/AccountsLayout.jsx";
import AccountDashBoard from "./Accounts/AccountDashBoard.jsx";
import Invoices from "./Accounts/Invoices.jsx";
import Invoicescharges from "./Crewing_Agent/Invoices/Invoicescharges.jsx";
import ChargesWrapper from "./Crewing_Agent/Invoices/ChargesWrapper.jsx";
import MonthlyInvoiceGenerator from "./Accounts/MonthlyInvoiceGenerator.jsx";
import InvoicesByAgentAndMonth from "./Accounts/InvoicesByAgentAndMonth.jsx";
import PendingSignOnTable from "./Contract/Modals/PendingSignOnList.jsx";
import PendingSignOffList from "./Contract/Modals/PendingSignOffList.jsx";
import SalarySlip from "./Contract/SalarySlip/SalarySlip.jsx";


const theme = createTheme();

function App() {
  const route = createBrowserRouter([
    {
      path: "/",
      element: <HomePage />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/signup",
      element: <Signup />,
    },
    {
      path: "/AdminDashboard",
      element: <AdminDashboard />,
    },
    {
      path: "/AllAdminContract",
      element: <AllAdminContract />
    },
    {
      path: "/AllAdminCrewing",
      element: <AllAdminCrewing />
    },
    {
      path: "/AdminContractDetails",
      element: <AdminContractDetails />
    },
    {
      path: "/adminSignup",
      element: <AdminSignup />
    },
    {
      path: "/otp",
      element: <Otp />
    },
    {
      path: "/forgotPassword",
      element: <ForgotPassword />
    },
    {
      path: "/crewprofile",
      element: <CrewProfile />,
    }, {
      path: "/CrewInfo/:id",
      element: <CrewInfo />
    },
    {
      path: "/AssignedCrew",
      element: <AssignedCrew />
    },
    {
      path: "/CrewProfileTable",
      element: <CrewProfileTable />
    },
    {
      path: "/AddRank/:id",
      element: <AddRank />
    },
    {
      path: "/AddRank",
      element: <CreateRank />
    },
    {
      path: "/RankTable",
      element: <RankTable />
    },
    {

      path: "/vessel_owner_table",
      element: <VesselOwnerTable />,
    },
    {
      path: "VesselOwnerContract",
      element: <VesselOwnerContract />

    },
    {
      path: "/VesselOwnerContract/:id",
      element: <VesselOwnerContracts />
    },
    {
      path: "/vesselownerform",
      element: <VesselOwnerForm />,

    },
    {
      path: "/manningAggrement",
      element: <ManningAggrement />,
    },
    {
      path: "/vessel",
      element: <VesselForm />,
    },
    {
      path: "/vessel_Table",
      element: <VesselTable />,
    },
    {
      path: "/vesselsforagent/:crewingAgentId",
      element: <Vesselsforagent />,
    },
    {
      path: "/CrewAssigned/:crewingAgentId",
      element: <CrewAssigned />
    },
    {
      path: "/vessel_Table/vessel/:id",
      element: <VesselForm />
    },
    {
      path: "/VesselTableByVesselOwnerId/:id",
      element: <VesselTableByVesselOwnerId />
    },
    {
      path: "/ManningAggrementDisplay",
      element: <ManningAggrementDisplay />,
    },
    //vessel Manger routes
    {
      path: "/VesselMangerForm",
      element: <VesselMangerForm />,
    },
    {
      path: "/VesselManagerTable",
      element: <VesselManagerTable />
    },
    {
      path: "/set-permissions",
      element: <SetPermissionPage />,
    },
    //Crewing_Agent routes
    {
      path: "/Crewing_Agent",
      element: <CrewingAgentForm />,
    },
    {
      path: `/CrewingAgentTable/:id`,
      element: <CrewingAgentTable />,
    },
    {
      path: "/CrewingAgentTable",
      element: <CrewingAgentTable />,
    },
    {
      path: `/SignInSignOff/:id`,
      element: <SignInSignOffCrewing />
    },
    {
      path: "/CrewingAgentFormIList/:crewingAgentId",
      element: <CrewingAgentFormIList />
    },
    {
      path: "/AssignedCrewList/:crewingAgentId",
      element: <AssignedCrewList />
    },
    {
      path: "/invoicecharges/:crewingAgentId",
      element: <ChargesWrapper />
    },
    {
      path: "/SeaServiceProfile/:crewingAgentId",
      element: <SeaServiceProfileWrapper />
    },
    // Vessel route with dynamic ID
    {
      path: "/vessel/:id",
      element: <VesselForm />,
    },
    {
      path: "/vessel_Table/:id",
      element: <VesselTable />
    },
    {
      path: "/vessel_Table/vesselTable/:id",
      element: <VesselTable />
    },
    //AssignedVesselTable
    {
      path: "/AssignedVesselTable",
      element: <AssignedVesselTable />
    },
    {
      path: "/AgentDetails",
      element: <AgentDetails />
    },
    //contract page route
    {
      path: "/ContractForm",
      element: <ContractForm />
    },
    {
      path: "/ContractForVesselOwner",
      element: <ContractForVesselOwner />
    },
    {
      path: "/ContractTable",
      element: <ContractTable />
    },
    {
      path: "/EditContractTable",
      element: <EditContractTable />
    },
    {
      path: "/ContractTable/:id",
      element: <ContractTable />
    },
    {
      path: "/salary-slip/:contractId",
      element: <SalarySlip />
    },
    {
      path: "/SignInSignOff",
      element: <SignInSignOff />
    },
    {
      path: "/getAllPendingSignOn",
      element: <PendingSignOnTable />
    },
    {
      path: "/PendingSignOffList",
      element: <PendingSignOffList />
    },
    {
      path: "/ContractUpdate/:id",
      element: <ContractUpdate />
    },
    {
      path: "/contractDocument",
      element: <CrewingAgentContractDocument />
    },
    {
      path: "/PendingFormI",
      element: <PendingFormI />
    },
    //compnay route
    {
      path: "/CompanyVessel",
      element: <CompanyVessel />
    },
    {
      path: "/ExecutiveForm/:id",
      element: <ExecutiveForm />
    },
    {
      path: "/ExecutiveVesselInfo/:id",
      element: <ExecutiveVesselInfo />
    },
    {
      path: "/ExecutiveVesselInfo",
      element: <ExecutiveVesselInfo />
    },
    {
      path: "/ExecutiveTable/:id",
      element: <ExecutiveTable />
    },
    {
      path: "/expiring-vessels",
      element: <ExpiringShipDetails />
    },
    {
      path: "/user-list",
      element: <UserList />
    },
    {
      path: "/crew-agent/:agentId",
      element: <CrewAgentDetails />
    },
    {
      path: "/CharteredVessel",
      element: <CharteredVessel />
    },
    //Accounts routes
    {
      path: "/accounts/secure/login",
      element: <AccountsLogin />
    },

    {
      path: "/accounts/secure",
      element: <AccountsLayout />,
      children: [
        { path: "dashboard", element: <AccountDashBoard /> },
        { path: "Invoices", element: <Invoices /> },
        // { path: "invoice/create", element: <InvoiceCreate /> },
        // { path: "invoice/list", element: <InvoiceList /> },
        { path: "invoices/monthly", element: <MonthlyInvoiceGenerator /> },
        { path: "invoices/crewingAgents", element: <InvoicesByAgentAndMonth /> },
        // { path: "settings/profile", element: <ProfileSettings /> },
        // { path: "settings/system", element: <SystemSettings /> },
      ],
    },

    //vessel owner routes
    {
      path: "/VesselOwnerLayouts/:id",
      element: <VesselOwnerLayouts />,
      children: [
        { index: true, element: <DashBoard /> },
        { path: "dashboard", element: <DashBoard /> },
        { path: "profile", element: <VesselOwnerProfile /> },
        { path: "vessels/addVessel", element: <AddVessel /> },
        { path: "vessels/list", element: <VesselList /> },
        { path: "vessels/assigned", element: <AssignedVessel /> },
        { path: "crew/add", element: <AddCrew /> },
        { path: "crew/list", element: <CrewList /> },
        { path: "contracts/bsm", element: <BsmContracts /> },
        { path: "contracts/owners", element: <VesselContarcts /> },
        { path: "executive/add", element: <AddExecutive /> },
        { path: "executive/list", element: <ExecutiveList /> },
      ]
    },

  ]);


  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <NotificationProvider>
          <RouterProvider router={route} />
        </NotificationProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}




export default App;
